module.exports = __webpack_public_path__ + "media/images/help/about/bg-reasons-06b89f753e2b9a6fe022e2ec4e0c51ff.svg";